export class EntitiesQuestions {
  public static question_entities = [
    { label: "Aguascalientes", value: { value: "Aguascalientes", incident: false } },
    { label: "Baja California", value: { value: "Baja California", incident: false } },
    { label: "Baja California Sur", value: { value: "Baja California Sur", incident: false } },
    { label: "Campeche", value: { value: "Campeche", incident: false } },
    { label: "Coahuila", value: { value: "Coahuila", incident: false } },
    { label: "Colima", value: { value: "Colima", incident: false } },
    { label: "Chiapas", value: { value: "Chiapas", incident: false } },
    { label: "Chihuahua", value: { value: "Chihuahua", incident: false } },
    { label: "Ciudad de México", value: { value: "Ciudad de México", incident: false } },
    { label: "Durango", value: { value: "Durango", incident: false } },
    { label: "Estado de México", value: { value: "Estado de México", incident: false } },
    { label: "Guanajuato", value: { value: "Guanajuato", incident: false } },
    { label: "Guerrero", value: { value: "Guerrero", incident: false } },
    { label: "Hidalgo", value: { value: "Hidalgo", incident: false } },
    { label: "Jalisco", value: { value: "Jalisco", incident: false } },
    { label: "Michoacán", value: { value: "Michoacán", incident: false } },
    { label: "Morelos", value: { value: "Morelos", incident: false } },
    { label: "Nayarit", value: { value: "Nayarit", incident: false } },
    { label: "Nuevo León", value: { value: "Nuevo León", incident: false } },
    { label: "Oaxaca", value: { value: "Oaxaca", incident: false } },
    { label: "Puebla", value: { value: "Puebla", incident: false } },
    { label: "Querétaro", value: { value: "Querétaro", incident: false } },
    { label: "Quintana Roo", value: { value: "Quintana Roo", incident: false } },
    { label: "San Luis Potosí", value: { value: "San Luis Potosí", incident: false } },
    { label: "Sinaloa", value: { value: "Sinaloa", incident: false } },
    { label: "Sonora", value: { value: "Sonora", incident: false } },
    { label: "Tabasco", value: { value: "Tabasco", incident: false } },
    { label: "Tamaulipas", value: { value: "Tamaulipas", incident: false } },
    { label: "Tlaxcala", value: { value: "Tlaxcala", incident: false } },
    {
      label: "Veracruz",
      value: { value: "Veracruz", incident: false },
    },
    { label: "Yucatán", value: { value: "Yucatán", incident: false } },
    { label: "Zacatecas", value: { value: "Zacatecas", incident: false } },
  ];
}
